module.exports = __webpack_public_path__ + "img/product_121.66bca3a.webp";